import React, { useEffect, useRef, useState } from 'react';
import { object, string } from 'prop-types';

import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import moment from 'moment';

import { CSVLink } from 'react-csv';

import Button from '@material-ui/core/Button';

import ActionBar from '../../components/ActionBar';
import AgentLogTimestampFilter from './AgentLogTimestampFilter';

import * as IotHubActions from '../../actions/iotHubActions';

import classes from './AgentLogDataFilters.module.css';
import { getTimeZoneAbbr } from '../../helpers/timezones';

const csvHeaders = [
    { key: 'dateTime', label: 'Date Time' },
    { key: 'logType', label: 'Log Level' },
    { key: 'messageTag', label: 'Message Tag' },
    { key: 'message', label: 'Message' }
];

const AgentLogDataFilters = ({
    data,
    logEndTimeStamp,
    logEntryRefresh,
    logName,
    logStartTimeStamp,
    reset,
    setLogEndTimeStamp,
    setLogSearchValue,
    setLogStartTimeStamp,
    ...props
}) => {

    const fileName = useRef();

    const [ maxDate, setMaxDate ] = useState();

    useEffect(() => {
        setMaxDate(moment().local());
    }, []);

    useEffect(() => {
        if (logName && data && data.length) {
            const zone = moment.tz.guess();
            const startTime = moment(data[0].dateTime).local().format('YYYY-MM-DDTHH:mm:ss') + ' ' + getTimeZoneAbbr(data[0].dateTime, zone);
            const endTime = moment(data[data.length - 1].dateTime).local().format('YYYY-MM-DDTHH:mm:ss') + ' ' + getTimeZoneAbbr(data[data.length - 1].dateTime, zone);

            fileName.current = `${logName}Log__${startTime}__${endTime}.csv`;
        }
    }, [data, logName]);

    const handleFilterChange = (filterName, value) => {
        if (filterName === 'startTimestamp') {
            if (value) {
                const earlierThanPriorStartTime = value.local().isBefore(moment(logStartTimeStamp).local());
                const isGreaterThan24Hours = moment(logEndTimeStamp).local().diff(value.local(), 'hours') > 24;

                setLogStartTimeStamp(moment(value.local()));
                

                if (earlierThanPriorStartTime && isGreaterThan24Hours) {
                    setLogEndTimeStamp(moment(value.clone()).add(24, 'h').local());
                }
                else {
                    const isLaterThanNow = moment(value.clone().add(24, 'h')).isAfter(moment().local);
                    const isLaterThanEndTime = moment(value.local()).isAfter(moment(logEndTimeStamp).local());
                    if (isLaterThanNow) {
                        setLogEndTimeStamp(moment().local());
                    }
                    else if (isLaterThanEndTime) {
                        if (moment(value.clone().add(24, 'h')).isAfter(moment().local())) {
                            setLogEndTimeStamp(moment().local());
                        }
                        else {
                            const newEndTime = moment(value.clone()).add(24, 'h');
                            setLogEndTimeStamp(newEndTime.local());
                        }
                    }
                    else {
                        setLogEndTimeStamp(moment(value.clone()).add(24, 'h'));
                    }
                }
            } else {
                setLogStartTimeStamp(moment().subtract(1,'h').local().startOf('hour'));
            }

        } else if (filterName === 'endTimestamp') {
            if (value) {
                const laterThanPriorEndTime = value.local().isAfter(moment(logEndTimeStamp).local());
                const isGreaterThan24Hours = value.local().diff(moment(logStartTimeStamp).local(), 'hours') > 24;
                const isBeforeStartTime = value.local().isBefore(moment(logStartTimeStamp).local());

                if (isBeforeStartTime || (laterThanPriorEndTime && isGreaterThan24Hours)) {
                    setLogStartTimeStamp(moment(value).subtract(24,'h').local());
                }
                setLogEndTimeStamp(value.local());

            } else {
                setLogEndTimeStamp(moment().local());
            }
        }
    };

    const handleFetch = () => {
        logEntryRefresh();
    };

    const handleReset = () => {
        reset();
    };

    const handleSearch = searchValue => {
        if (isEmpty(searchValue)) {
            setLogSearchValue();

            return;
        }

        // Grab just the first 1024 characters, AWS CloudWatch only supports searches of 1024
        // characters and fewer.
        const legalLengthSearchValue = searchValue.substring(0, 1024);

        setLogSearchValue(legalLengthSearchValue);
    };

    return (
        <React.Fragment>
            <div className={classes.AgentLogDataFilters}>
                <div className={classes.filterControls}>
                    <div className={classes.timestampFilterWrapper}>
                        <AgentLogTimestampFilter
                            endTimestamp={logEndTimeStamp}
                            onFilterChange={handleFilterChange}
                            startTimestamp={logStartTimeStamp}
                            maxDate={maxDate}
                        />
                    </div>
                    <Button
                        className={classes.filterButton}
                        onClick={handleFetch}
                    >
                        Fetch
                    </Button>
                    <Button
                        className={classes.filterButton}
                        onClick={handleReset}
                    >
                        Reset
                    </Button>
                </div>
                <div className={classes.filterActionBar}>
                    <ActionBar
                        onSearch={handleSearch}
                    >
                        <CSVLink
                            className={classes.exportLink}
                            data={data || []}
                            filename={fileName.current}
                            headers={csvHeaders}
                        >
                            <img src="/assets/images/exportIconFlat.svg" alt="" />
                            Export
                        </CSVLink>
                    </ActionBar>
                </div>
            </div>
        </React.Fragment>
    );
};

AgentLogDataFilters.defaultProps = {
    logEndTimeStamp:   {},
    logSearchValue:    '',
    logStartTimeStamp: {}
};

AgentLogDataFilters.propTypes = {
    logEndTimeStamp:   object,
    logSearchValue:    string,
    logStartTimeStamp: object
};

const mapStateToProps = state => {
    return {
        logEndTimeStamp:   state.iotHub.logEndTimeStamp,
        logSearchValue:    state.iotHub.logSearchValue,
        logStartTimeStamp: state.iotHub.logStartTimeStamp
    };
};

const mapDispatchToProps = {
    ...IotHubActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AgentLogDataFilters);
